import usePostData from '../../../../../hooks/postHook';

export const useAddCategory = ({ mode }) => {
  const [{ data, body, isLoading, isError, error }, doAddCategory] =
    usePostData(``, {
      type: mode === 'add' ? 'post' : 'put',
    });

  return { data, body, isLoading, isError, error, doAddCategory };
};
